export enum ShopilinkSettingTypes {
  LOGO = 'logo',
  FAV_ICON='favIcon',
}
